/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_TrialingInputs */

const en_settings_billing_tab_trialing = /** @type {(inputs: Settings_Billing_Tab_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trialing`)
};

const zh_settings_billing_tab_trialing = /** @type {(inputs: Settings_Billing_Tab_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用中`)
};

/**
* | output |
* | --- |
* | "Trialing" |
*
* @param {Settings_Billing_Tab_TrialingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_trialing = /** @type {((inputs?: Settings_Billing_Tab_TrialingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_TrialingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_tab_trialing(inputs)
	return zh_settings_billing_tab_trialing(inputs)
});
export { settings_billing_tab_trialing as "settings.billing.tab_trialing" }